import { createApiSlice } from "@common";
import {
  CRUD_CAMPAIGN_CHANNEL
} from "@routes";

const apiConfig = [
  {
    name: "addCampaignChannel",
    method: "post",
    url: CRUD_CAMPAIGN_CHANNEL,
    stateKey: "message",
  },
  {
    name: "getCampaignChannel",
    method: "get",
    url: CRUD_CAMPAIGN_CHANNEL,
    stateKey: "data",
  },
  {
    name: "updateCampaignChannel",
    method: "put",
    url: CRUD_CAMPAIGN_CHANNEL,
    stateKey: "message",
  },
  {
    name: "deleteCampaignChannel",
    method: "delete",
    url: CRUD_CAMPAIGN_CHANNEL,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "campaignChannel",
  apiConfig,
  customReducers,
);
const campaignChannelSlice = slice;

export default campaignChannelSlice.reducer;

export const {
  addCampaignChannel,
  getCampaignChannel,
  updateCampaignChannel,
  deleteCampaignChannel,
  getCampaignChannelByCampaignId,
} = thunks;

export const { rowSelect } = actions;
